import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "my-5" }
const _hoisted_2 = { class: "bodyTEXT" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, computed, watch, Ref, onMounted } from 'vue';
import axios from 'axios';



/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import copyComponent from './copyComponent.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { APIS_INVENTORY } from '@/constants/apis';
import { TIMEOUTTIME } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { GENERAL_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';



export default /*@__PURE__*/_defineComponent({
  __name: 'AddEditComponent',
  props: {
    itemObject  : { type: Object, required:true }
},
  emits: ['closeDialog'],
  setup(__props, { emit: __emit }) {

const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
const {xs, md,smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();


/********************************
 ********** COMPONENTS **********
 *******************************/
const props = __props
const emits = __emit;

//==================================================//
//==================== VARIABLES ===================//
//==================================================//

/**
 * Vue / Vuetify
 */

const finalItem             = computed(() => props.itemObject);
const subTypeSelect         = ref(['']);
const typeSelect            = ref(['']);
const markSelect:Ref<string[]>      = ref([]);
const snmpConfSelect:Ref<string[]>  = ref([]);

/**
 * Component
 */

const id            = ref(finalItem.value.id);
const ip            = ref(finalItem.value.ip);
const tag           = ref(finalItem.value.tag);
const mark          = ref(finalItem.value.marca);
const rol           = ref(finalItem.value.rol);
const type          = ref(finalItem.value.tipo);
const snmp_conf     = ref(finalItem.value.snmp_conf??'0');
const anotacion     = ref(finalItem.value.anotacion??'{}');
const gps           = ref(finalItem.value.gps??'{"latitud" : 0, "longitud" : 0, "altitud" : 0}');
const typeDialog    = ref(finalItem.value.typeDialog);

const latitude      = ref(JSON.parse(gps.value).latitud);
const longitude     = ref(JSON.parse(gps.value).longitud);
const altitude      = ref(JSON.parse(gps.value).altitud);

const getIPS        = computed(() => store.state.arrayListItems );

const allDataBase = [
    'cambium_data', 'clustering_data', 'eventos', 'latencia', 'LTE_data', 
    'predicciones', 'rajant_data', 'sensores', 'servidor_data', 'ubicacion_gps', 'inventario'
]

const copyDialog    = ref(false);

const newAdd        = ref(false);
const disableADDbtn = ref(true);
const disableByIP   = ref(true);
const disableNewEDT = ref(false);
const errorIP:Ref<((v: string) => string | true)[]>       = ref([])

const disableEDTbtn = computed( ()=>
    (tag.value === finalItem.value.tag &&
    mark.value === finalItem.value.marca && type.value === finalItem.value.tipo &&
    anotacion.value === finalItem.value.anotacion && snmp_conf.value === finalItem.value.snmp_conf &&
    rol.value === finalItem.value.rol && gps.value === finalItem.value.gps && latitude.value === JSON.parse(gps.value).latitud &&
    longitude.value === JSON.parse(gps.value).longitud && altitude.value === JSON.parse(gps.value).altitud) && disableByIP.value

    // latitudePAST.value      = latitude.value;
    // longitudePAST.value     = longitude.value;
    // altitudePAST.value      = altitude.value
)

// const api           = CONSTAPIS.APIS.value.general.inventory;

const params        = ref({});

const width         = computed(() => md.value?'100%':smAndDown.value?'85%':'900px');
const valid         = ref(true);
const fieldRules    = computed ( () => [ (v:string) => !!v ||  t('labels.error.required') ]);

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Send all Form Data to API
 */
const editItem = async () => {

    newAdd.value    = false;

    await getParams();
    
    await axios.post(APIS_INVENTORY.value.postEditInventoryData,params.value, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) =>{

        if(!response.data.error){

            store.dispatch('getInventoryData');
            emitDialogClose();

            store.dispatch('showSnackBar', {type: 'setSnackEdit', msg: t('snackbar.edit')});


            disableNewEDT.value = false;
            
        }
        else{
            showErrorSnackBar('snackbar.errorEdit');
        }

    })
    .catch(function (error) {
        showConsoleError(error);
        showErrorSnackBar('snackbar.errorEdit');
    });
}

const addItem = async () => {
    newAdd.value    = true;

    await getParams();

    await axios.post(APIS_INVENTORY.value.postAddInventoryData,params.value, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) =>{

        if(!response.data.error){

            store.dispatch('getInventoryData'); 
            store.dispatch('showSnackBar', {type: 'setSnackAdd', msg: t('snackbar.add')});
            
            disableADDbtn.value = true;
            disableByIP.value   = true;
            disableNewEDT.value = true;

        }
        else{
            showErrorSnackBar('snackbar.errorAdd');
        }
    })
    .catch(function (error) {
        showConsoleError(error);
        showErrorSnackBar('snackbar.errorAdd');
    });
}

const deleteItem = async () => {

    allDataBase.forEach(async(database:string)=> {
        let param = {
            table   : database,
            ip      : ip.value, 
            id      : id.value
        }

        await axios.post(APIS_INVENTORY.value.postDeleteInventoryData,{params:param}, { headers: { "Authorization": `Bearer ${TOKEN}` }}, ).then((response) => {
            if(!response.data.error){

                if(database === 'inventario'){
                    store.dispatch('getInventoryData'); 
                    emitDialogClose();
                    store.dispatch('showSnackBar', {type: 'setSnackDelete', msg: t('snackbar.delete')});
                }

            }
            else{
                showErrorSnackBar('snackbar.errorDelete')
            }
        })
        .catch(function (error) {
            showConsoleError(error);
            showErrorSnackBar('snackbar.errorDelete');
        });
    })
    
}


const showErrorSnackBar = (errorMsg:string) => {

    store.dispatch('showSnackBar', {type: 'setSnackError', msg: t(`${errorMsg}`)});

}


const getParams = async () => {
    let finalGPS = {
        "latitud"   : parseFloat(latitude.value),
        "longitud" : parseFloat(longitude.value),
        "altitud"  : parseFloat(altitude.value),
    }
    params.value = {
        id          : newAdd.value ? null : id.value,
        ip          : ip.value,
        tag         : tag.value,
        marca       : mark.value,
        tipo        : type.value,
        rol         : rol.value,
        snmp_conf   : parseInt(snmp_conf.value),
        anotacion   : anotacion.value,
        gps         : JSON.stringify(finalGPS),
    }
}

const emitDialogClose = () => {
    emits('closeDialog');
}


const showCopyDialog = () => {
    copyDialog.value = true;
}
const closeCopyDialog = () => {
    copyDialog.value = false;
}


watch(ip,(getIP)=>{

    if(finalItem.value.ip === getIP){
        disableADDbtn.value = true;
        disableByIP.value   = true;
    }
    else{
        let boolprev            = false;
        let finalerror:((v: string) => string | true ) []    = [
                (v:string) => !!v ||  t('labels.error.required')
        ];
        getIPS.value.find(({ip}:GENERAL_EQUIPAMENT) => {
            if(ip === getIP.toString()){
                boolprev = true;
                finalerror = [
                    (v:string) => !!v || t('labels.error.required'),
                    (v:string) => v === null  || 'IP DUPLICADA'
                ]
            }
        })
        disableADDbtn.value = boolprev;
        disableByIP.value   = boolprev;
        errorIP.value       = finalerror;
    }
})         
       
onMounted(()=> {
    
    /**
     * Capturamos el subtipo del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getSubtypeInv, { timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((subtype)=>{
        subTypeSelect.value.pop();
        subtype.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            subTypeSelect.value.push(item.name??'')
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    /**
     * Capturamos el tipo del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getTypeInv,{ timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((subtype)=>{
        typeSelect.value.pop();
        subtype.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            typeSelect.value.push(item.name??'')
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    /**
     * Capturamos la marca del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getMarkInventory,{ timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((mark)=>{
        mark.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            markSelect.value.push(item.name??'');
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    /**
     * Capturamos la configuracion SNMP del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getSNMPInventory,{ timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((snmp)=>{
        snmp.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            snmpConfSelect.value.push(item.name??'');
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });
})


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (typeDialog.value === 'delete')
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 0,
          color: "bgtopology",
          width: "90%",
          class: "defaultCard",
          style: {"margin":"0 auto !important"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('labels.dialogDelete')), 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('labels.bodyDialog.delete')) + " " + _toDisplayString(tag.value), 1),
            _createVNode(_component_v_divider, { class: "my-4" }),
            _createVNode(_component_v_row, {
              justify: _unref(smAndDown) ? 'center' : 'end',
              class: "ma-0 mt-6 mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: _normalizeClass(_unref(smAndDown)?'ma-2':'mx-2'),
                  color: "success",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteItem())),
                  block: _unref(xs)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttons.yes')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "block"]),
                _createVNode(_component_v_btn, {
                  class: _normalizeClass(_unref(smAndDown)?'ma-2':'mx-2'),
                  color: "red",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emitDialogClose())),
                  block: _unref(xs)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttons.not')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "block"])
              ]),
              _: 1
            }, 8, ["justify"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_sheet, {
          key: 1,
          color: "bgtopology",
          width: "100%",
          class: "defaultCard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between",
              style: {"align-items":"center !important"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pa-0",
                  cols: "10"
                }, {
                  default: _withCtx(() => [
                    (typeDialog.value === 'add')
                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 0,
                          color: "transparent"
                        }, {
                          default: _withCtx(() => [
                            (_unref(xs))
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(t)('labels.addTitle')), 1))
                              : (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)('labels.addTitle')), 1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (typeDialog.value === 'edit')
                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 1,
                          color: "transparent"
                        }, {
                          default: _withCtx(() => [
                            (_unref(xs))
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_unref(t)('labels.editTitle')), 1))
                              : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_unref(t)('labels.editTitle')), 1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "pa-0",
                  cols: "1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      variant: "plain",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (emitDialogClose()))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "mt-4 mb-7" }),
            _createVNode(_component_v_form, {
              modelValue: valid.value,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((valid).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "3",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: ip.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ip).value = $event)),
                          label: _unref(t)('labels.ip') + ' *',
                          variant: "underlined",
                          density: "compact",
                          rules: errorIP.value
                        }, null, 8, ["modelValue", "label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "3",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: tag.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tag).value = $event)),
                          label: _unref(t)('labels.name') + ' *',
                          variant: "underlined",
                          density: "compact",
                          rules: fieldRules.value
                        }, null, 8, ["modelValue", "label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "3",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: mark.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((mark).value = $event)),
                          items: markSelect.value,
                          label: _unref(t)('labels.mark')  + ' *',
                          variant: "underlined",
                          density: "compact",
                          rules: fieldRules.value
                        }, null, 8, ["modelValue", "items", "label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "3",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: rol.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((rol).value = $event)),
                          items: subTypeSelect.value,
                          label: _unref(t)('labels.subtype')  + ' *',
                          variant: "underlined",
                          density: "compact",
                          rules: fieldRules.value
                        }, null, 8, ["modelValue", "items", "label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "3",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: type.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((type).value = $event)),
                          items: typeSelect.value,
                          label: _unref(t)('labels.type')  + ' *',
                          variant: "underlined",
                          density: "compact",
                          rules: fieldRules.value
                        }, null, 8, ["modelValue", "items", "label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "3",
                      lg: "3",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: snmp_conf.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((snmp_conf).value = $event)),
                          items: snmpConfSelect.value,
                          label: _unref(t)('labels.snmp_conf')  + ' *',
                          variant: "underlined",
                          density: "compact"
                        }, null, 8, ["modelValue", "items", "label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4",
                      md: "6",
                      lg: "6",
                      xl: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: anotacion.value,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((anotacion).value = $event)),
                          label: _unref(t)('labels.annotation'),
                          variant: "underlined",
                          density: "compact",
                          hint: "Formato: {\"item\": \"value\", \"item2\": \"value2\"...}"
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "px-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "ma-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "4",
                              md: "3",
                              lg: "3",
                              xl: "3",
                              class: "pa-0 pl-0 pr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: latitude.value,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((latitude).value = $event)),
                                  label: _unref(t)('labels.latitude'),
                                  variant: "underlined",
                                  density: "compact",
                                  type: 'number',
                                  "hide-spin-buttons": ""
                                }, null, 8, ["modelValue", "label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "4",
                              md: "3",
                              lg: "3",
                              xl: "3",
                              class: "pa-0 px-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: longitude.value,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((longitude).value = $event)),
                                  label: _unref(t)('labels.longitude'),
                                  variant: "underlined",
                                  density: "compact",
                                  type: 'number',
                                  "hide-spin-buttons": ""
                                }, null, 8, ["modelValue", "label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "4",
                              md: "3",
                              lg: "3",
                              xl: "3",
                              class: "pa-0 px-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: altitude.value,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((altitude).value = $event)),
                                  label: _unref(t)('labels.altitude'),
                                  variant: "underlined",
                                  density: "compact",
                                  type: 'number',
                                  "hide-spin-buttons": ""
                                }, null, 8, ["modelValue", "label"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (typeDialog.value === 'edit')
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      class: "ma-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          class: _normalizeClass(_unref(smAndDown) ? 'pa-0' : 'pa-0 pr-2'),
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (editItem())),
                              disabled: (!valid.value && valid.value !== null && valid.value !== undefined) || (disableEDTbtn.value && disableByIP.value) || disableNewEDT.value,
                              class: _normalizeClass(_unref(smAndDown) ? 'mt-3' : 'mt-10'),
                              "prepend-icon": "mdi-pencil",
                              color: "success",
                              block: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('buttons.change' )), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_col, {
                          class: _normalizeClass(_unref(smAndDown) ? 'pa-0' : 'pa-0 pr-2'),
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (addItem())),
                              disabled: (!valid.value && valid.value !== null && valid.value !== undefined) || disableADDbtn.value,
                              class: _normalizeClass(_unref(smAndDown) ? 'mt-3' : 'mt-10'),
                              "prepend-icon": "mdi-check-circle",
                              color: "success",
                              block: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('buttons.add' )), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_col, {
                          class: _normalizeClass(_unref(smAndDown) ? 'pa-0' : 'pa-0 pr-2'),
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (showCopyDialog())),
                              disabled: (!valid.value && valid.value !== null && valid.value !== undefined),
                              class: _normalizeClass(_unref(smAndDown) ? 'mt-3' : 'mt-10'),
                              "prepend-icon": "mdi-check-circle",
                              color: "success",
                              block: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('buttons.copy' )), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "class"])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (typeDialog.value === 'add')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (addItem())),
                      disabled: (!valid.value && valid.value !== null && valid.value !== undefined) || disableADDbtn.value,
                      class: "mt-10",
                      "prepend-icon": "mdi-check-circle",
                      color: "success",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.add' )), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })),
    _createVNode(_component_v_dialog, {
      modelValue: copyDialog.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((copyDialog).value = $event)),
      width: width.value
    }, {
      default: _withCtx(() => [
        _createVNode(copyComponent, {
          itemObject: __props.itemObject,
          arraySubtype: subTypeSelect.value,
          arrayType: typeSelect.value,
          arrayMark: markSelect.value,
          arraySNMP: snmpConfSelect.value,
          onCloseCopyDialog: closeCopyDialog
        }, null, 8, ["itemObject", "arraySubtype", "arrayType", "arrayMark", "arraySNMP"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}
}

})